/* eslint-disable */

/* This file is generated, don't modify directly. See README.md in Icon folder */
import React from 'react';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
type Props = Omit<SvgIconProps, 'viewBox'>;
export function IconZoomOut1(props: Props) {
    const newProps = { ...props, viewBox: '0 0 32 32' };
    return React.createElement(
        SvgIcon,
        newProps,
        <path
            d="M32 29.174c0-.377-9.365-9.305-9.677-9.557s-.187-.817.125-1.509 3.871-8.299-1.374-13.958S7.713-1.131 3.218 3.773c-4.495 4.904-4.121 12.826.125 16.662s9.87 5.156 14.924 1.949c.876-.508 1.375.247 1.375.247s9.056 9.24 9.43 9.366c.375.126 2.927-2.445 2.927-2.822zM5.047 10.606c.209-.093 13.605-.151 13.783-.029s.144 3.147-.006 3.301c-.149.154-13.516.181-13.664.029s-.322-3.208-.113-3.3z"
            fill="currentColor"
        />
    );
}
